import React, { Component } from 'react';

/*Material ui template */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';



export default class CaInfo extends Component {
  
  static propTypes = {

  };
    
  state = {
  };

  render() {
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Control Account Information
        </Typography>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="name"
              name="name"
              label="Name"
              fullWidth
              autoComplete="pname"
              value={this.props.ca.name}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.name}
              helperText={this.props.errores.name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="charge_account"
              name="charge_account"
              label="Charge Account"
              fullWidth
              autoComplete="charge_account"
              value={this.props.ca.charge_account}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.charge_account}
              helperText={this.props.errores.charge_account}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              style={{width: '90%'}}
              id="start_date"
              label="Start Date"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              value={this.props.ca.start_date}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.start_date}
              helperText={this.props.errores.start_date}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              style={{width: '90%'}}
              id="end_date"
              label="End Date"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              value={this.props.ca.end_date}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.end_date}
              helperText={this.props.errores.end_date}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="responsible"
              name="responsible"
              label="Responsible"
              fullWidth
              autoComplete="responsible"
              value={this.props.ca.responsible}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.responsible}
              helperText={this.props.errores.responsible}
            />
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/ca/CaInfo.js